import FadingBalls from "./FadingBalls";

function DashboardPlaceholder() {
    return <FadingBalls text={"Loading..."} />;
}

export default DashboardPlaceholder;
